import Point from "esri/geometry/Point";
import Polygon from "esri/geometry/Polygon";

// General --------------------------------------------------
export enum nvrTools {
  removal = "Removal",
  offset = "Offset",
}

export type nvrToolModes = nvrTools;

export enum featureTypes {
  patch = "patch",
  tree = "tree",
  revegetationArea = "revegetationArea",
}

export enum mapAdditionalModes {
  identify = "identify",
  measure = "measure",
  edit = "edit",
}

export type mapModes = featureTypes | mapAdditionalModes;

export enum basemapTypes {
  esriTile,
  wmts,
}

// Features --------------------------------------------------
export enum featureSource {
  Drawn = "Drawn",
  Uploaded = "Uploaded",
}

export enum treeType {
  Patch = "Patch",
  Scattered = "Scattered",
}

export enum treeCmType {
  DBH = "DBH",
  CIR = "CIR",
}

export enum treeSize {
  Lg = "Lg",
  Sm = "Sm",
}

export interface Feature {
  id: string;
  source: featureSource;
  geom?: Point | Polygon;
}

export interface Patch extends Feature {
  area: number;
}

export interface Tree extends Feature {
  type: treeType;
  cm: number;
  cmType: treeCmType;
  size: treeSize;
  vegCode: string | undefined;
  benchmark: string | undefined;
  benchmarkCm: number | undefined;
}

export interface RevegetationArea extends Feature {
  area: number;
  apRatio: number;
}

export enum featureTypeFieldValues {
  patch = "p",
  scatteredTree = "st",
  patchTree = "pt",
  revegetationArea = "rv",
}

export enum processingStatuses {
  processing = "processing",
  completed = "completed",
  failed = "failed",
}

export enum validations {
  invalidPolygon = "invalidPolygon",
  overlappingTypes = "overlappingTypes",
  msaLevyArea = "msaLevyArea",
  msaConservation = "msaConservation",
  msa12Precincts = "msa12Precincts",
  apRatio = "apRatio",
  treesBelowDbhThreshold = "treesBelowDbhThreshold",
  wetlands = "wetlands",
  nonWoodyEvc = "nonWoodyEvc",
  parcelBoundaryProximity = "parcelBoundaryProximity",
  outsideSupportingRasters = "outsideSupportingRasters",
}

export enum validationFeatureCreationContext {
  draw = "draw",
  edit = "edit",
  upload = "upload",
}

export interface ValidationResult {
  fail?: boolean;
  messageContent?: any;
  messageTitle?: string;
}
